import * as React from 'react'

/**
 * When the keyboard opens on iOS, it pushes the screen down. This hook
 * counteracts this by scrolling back to the top when the keyboard closes (i.e.
 * when the input loses focus/blurs).
 *
 * TODO: Don't think this actually works as intended on mobile Safari.
 * TODO: Right now it doesn't work on the live site because we are trying to
 * scroll from an iframe. It should work if the iframe domain is the same as the
 * parent domain, which isn't the case right now. (Netlify domain -> Ridebelay)
 */
export const useScrollToTop = (
  inputElement: React.MutableRefObject<HTMLInputElement>
): void => {
  React.useEffect(() => {
    if (inputElement.current) {
      inputElement.current.onblur = () => {
        window.scrollTo(0, 0)
        document.body.scrollTop = 0
      }
    }
  }, [inputElement])
}
